import { useState, useEffect, useRef } from "react";
import {
  Autocomplete,
  DatePicker,
  Grid,
  TextField,
  FormControl,
  TextFielDecimalNumbers,
  Divider,
  Checkbox,
  FormControlLabel,
} from "../../../../components";
import {
  GrupoProdutosService,
  PessoaService,
  SessionService,
} from "../../../../services";
import { value } from "../../../../helpers";
import { responseErros, timeoutBuscaAutocomplete } from "../../../../utils";
import { useFiltrosRelatoriosHandlers } from "../../components/use-filtros-relatorios-handlers";

const pessoaService = new PessoaService();
const grupoProdutosService = new GrupoProdutosService();
const subgrupoProdutosService = new GrupoProdutosService();

const FormFiltroAvancadoDesvioPreco = ({
  filtrosAvancados,
  setFiltrosAvancados,
  filtrosAplicadosImpressao,
  setFiltrosAplicadosImpressao,
  setValidationError
}) => {
  // const inputRefCliente = useRef();
  const inputRefFornecedor = useRef();
  const inputRefVendedor = useRef();
  // const [clienteList, setClienteList] = useState([]);
  const [fornecedorList, setFornecedorList] = useState([]);
  const [vendedorList, setVendedorList] = useState([]);
  const [grupoProdutoList, setGrupoProdutoList] = useState([]);
  const [subgrupoProdutoList, setSubgrupoProdutoList] = useState([]);
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);
  const { onChangeInput, onChangeAutocomplete, onChangeDate, onChangeCheckbox } =
    useFiltrosRelatoriosHandlers(
      setFiltrosAvancados,
      setFiltrosAplicadosImpressao
    );

  const sessionService = new SessionService();
  const usuario = sessionService.getUsuario();
  const empresa = sessionService.getEmpresa();

  useEffect(() => {
    setEstadoInicialFiltrosNfSaida();
    buscarGruposProduto();
    buscarSubgruposProduto();
  }, []);

  const buscarGruposProduto = () => {
    const filtros = {
      attributes: ['id', 'codigo', 'descricao'],
      disabledInclude: true,
      nonPaginated: true,
    };
    grupoProdutosService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setGrupoProdutoList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarSubgruposProduto = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
    };
    subgrupoProdutosService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setSubgrupoProdutoList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  function setEstadoInicialFiltrosNfSaida() {
    const filtros = {
      ...filtrosAvancados,
      empresasIds: [empresa.id],
    };
    let filtrosImpressao = {};
    if (usuario?.acessosEmpresas?.length) {
      filtrosImpressao = {
        ...filtrosAplicadosImpressao,
        ["Empresas-Associadas"]: empresa.razaoSocial,
      };
    }

    if (!filtros?.canceladas) {
      filtros.canceladas = "false";
      filtrosImpressao["Notas-Canceladas"] = "Não";
    }

    if (!filtros?.tipoOperacao) {
      filtros.tipoOperacao = "SAIDA";
      filtrosImpressao["Tipo-Operação"] = "Saída";
    }

    setFiltrosAvancados(filtros);
    setFiltrosAplicadosImpressao(filtrosImpressao);
  }

  // const buscarClientes = () => {
  //   const filtros = {
  //     nonPaginated: true,
  //     tiposPessoaId: 1,
  //   };
  //   pessoaService.getAll(filtros).then((result) => {
  //     if (!result.isAxiosError) {
  //       setClienteList(result.data);
  //     } else {
  //       responseErros(result);
  //     }
  //   });
  //   setLoadingAutoComplete(false);
  // };

  const buscarFornecedores = () => {
    const filtros = {
      nonPaginated: true,
      tiposPessoaId: 2,
    };
    pessoaService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setFornecedorList(result.data);
      } else {
        responseErros(result);
      }
    });
    setLoadingAutoComplete(false);
  };

  const buscarVendedores = () => {
    const filtro = {
      nonPaginated: true,
      vendedor: true,
      tiposPessoaId: 4,
    };
    pessoaService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setVendedorList(result.data);
      } else {
        responseErros(result);
      }
    });
    setLoadingAutoComplete(false);
  };

  const onInputChangePessoa = (event, tiposPessoaId) => {
    const inputRefMap = {
      // 1: {
      //   inputRef: inputRefCliente,
      //   buscar: buscarClientes,
      // },
      2: {
        inputRef: inputRefFornecedor,
        buscar: buscarFornecedores,
      },
      4: {
        inputRef: inputRefVendedor,
        buscar: buscarVendedores,
      },
    };
    const { inputRef, buscar } = inputRefMap[tiposPessoaId] || {};
    if (
      event.key === "Enter" &&
      inputRef?.current === document.activeElement &&
      event.target?.value?.length > 2
    ) {
      setLoadingAutoComplete(true);
      const filtros = {
        nomeRazaoSocial: event.target.value,
        apelidoFantasia: event.target.value,
      };
      timeoutBuscaAutocomplete(buscar?.(filtros));
    }
  };

  function onChangeMultipleEmpresas(empresas) {
    if (empresas.length === 0) {
      return;
    }
    setFiltrosAvancados((prevState) => ({
      ...prevState,
      empresasIds: empresas.map(({ id }) => id),
    }));
    setFiltrosAplicadosImpressao((prevState) => ({
      ...prevState,
      "Empresas-Associadas": empresas
        .map(({ razaoSocial }) => razaoSocial)
        .join(" | "),
    }));
  }

  return (
    <>
      {usuario?.acessosEmpresas?.length > 0 && (
        <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Autocomplete
              multiple
              id="empresasIds"
              name="empresasIds"
              options={usuario.acessosEmpresas}
              noOptionsText="Sem opções"
              autoHighlight
              disablePortal
              filterSelectedOptions
              getOptionLabel={(option) => option?.razaoSocial || ""}
              onChange={(_, newValue) => onChangeMultipleEmpresas(newValue)}
              value={value.multiple(
                usuario.acessosEmpresas || [],
                filtrosAvancados["empresasIds"]
                  ? filtrosAvancados["empresasIds"]
                  : ""
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  required
                  label="Empresas"
                  margin="normal"
                />
              )}
            />
          </Grid>
        </Grid>
        <Divider sx={{ mt: 2, mb: 1, border: "1px solid grey" }}/>
        </>
      )}
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField
            id="codigoInicial"
            label="Faixa de Código (Inicial)"
            name="codigoInicial"
            margin="normal"
            onChange={(e) => onChangeInput(e, "Código-Inicial")}
            value={value.text(filtrosAvancados?.codigoInicial)}
            fullWidth
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            id="codigoFinal"
            label="Faixa de Código (Final)"
            name="codigoFinal"
            margin="normal"
            onChange={(e) => onChangeInput(e, "Código-Final")}
            value={value.text(filtrosAvancados?.codigoFinal)}
            fullWidth
          />
        </Grid>
      </Grid>
      {/* <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="clienteId"
              name="Cliente"
              options={clienteList}
              autoHighlight
              disablePortal
              getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
              getOptionSelected={(option, value) =>
                option?.nomeRazaoSocial === value?.nomeRazaoSocial
              }
              loading={loadingAutoComplete}
              loadingText="Carregando"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Cliente"
                  variant="outlined"
                  onKeyDown={(e) => onInputChangePessoa(e, 1)}
                  inputRef={inputRefCliente}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
              onChange={(e, value) =>
                onChangeAutocomplete("clienteId", value, "Cliente")
              }
              value={value.autoComplete(
                clienteList,
                filtrosAvancados?.clienteId
              )}
            />
          </FormControl>
        </Grid>
      </Grid> */}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="fornecedorId"
              name="Fornecedor"
              options={fornecedorList}
              autoHighlight
              disablePortal
              getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
              getOptionSelected={(option, value) =>
                option?.nomeRazaoSocial === value?.nomeRazaoSocial
              }
              loading={loadingAutoComplete}
              loadingText="Carregando"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Fornecedor"
                  variant="outlined"
                  onKeyDown={(e) => onInputChangePessoa(e, 2)}
                  inputRef={inputRefFornecedor}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
              onChange={(e, value) =>
                onChangeAutocomplete("fornecedorId", value, "Fornecedor")
              }
              value={value.autoComplete(
                fornecedorList,
                filtrosAvancados?.fornecedorId
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="vendedorId"
              name="Vendedor"
              options={vendedorList}
              autoHighlight
              disablePortal
              getOptionLabel={(option) => option?.nomeRazaoSocial ?? ""}
              getOptionSelected={(option, value) =>
                option?.nomeRazaoSocial === value?.nomeRazaoSocial
              }
              loading={loadingAutoComplete}
              loadingText="Carregando"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Vendedor"
                  variant="outlined"
                  onKeyDown={(e) => onInputChangePessoa(e, 4)}
                  inputRef={inputRefVendedor}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
              onChange={(e, value) =>
                onChangeAutocomplete("vendedorId", value, "Vendedor")
              }
              value={value.autoComplete(
                vendedorList,
                filtrosAvancados?.vendedorId
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="grupoProdutoId"
              name="grupoProdutoId"
              options={grupoProdutoList}
              noOptionsText="Sem opções"
              autoHighlight
              disablePortal
              getOptionLabel={(option) => (option ? option.descricao : "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Grupo de Produto"
                  variant="outlined"
                />
              )}
              onChange={(_, newValue) => {
                onChangeAutocomplete(
                  "grupoProdutoId",
                  newValue,
                  "Grupo de Produtos"
                );
              }}
              value={value.autoComplete(
                grupoProdutoList,
                filtrosAvancados?.grupoProdutoId
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={6}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="subgrupoProdutoId"
              name="subgrupoProdutoId"
              options={subgrupoProdutoList}
              noOptionsText="Sem opções"
              autoHighlight
              disablePortal
              getOptionLabel={(option) => (option ? option.descricao : "")}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Subgrupo de Produto"
                  variant="outlined"
                />
              )}
              onChange={(_, newValue) => {
                onChangeAutocomplete(
                  "subgrupoProdutoId",
                  newValue,
                  "Subgrupo de Produtos"
                );
              }}
              value={value.autoComplete(
                grupoProdutoList,
                filtrosAvancados?.subgrupoProdutoId
              )}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <DatePicker
            id="dataLancamentoStart"
            name="Data-Inicial"
            label="Data Inicial"
            margin
            format="dd/MM/yyyy"
            value={value.date(filtrosAvancados?.dataLancamentoStart)}
            onChange={(date) =>
              onChangeDate("dataLancamentoStart", date, "Data-Inicial")
            }
            slotProps={{
              popper: { sx: { zIndex: 2000 }, }
            }}
            setError={setValidationError}
          />
        </Grid>
        <Grid item xs={6}>
          <DatePicker
            id="dataLancamentoEnd"
            name="Data-Final"
            label="Data Final"
            margin
            format="dd/MM/yyyy"
            value={value.date(filtrosAvancados?.dataLancamentoEnd)}
            onChange={(date) =>
              onChangeDate("dataLancamentoEnd", date, "Data-Final")
            }
            slotProps={{
              popper: { sx: { zIndex: 2000 }, }
            }}
            setError={setValidationError}
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextFielDecimalNumbers
            label="Desvio Mínimo (%)"
            id="desvioMinimo"
            name="desvioMinimo"
            value={value.text(filtrosAvancados?.desvioMinimo)}
            onBlur={(e) => onChangeInput(e, "Desvio-Mínimo", "number")}
            fullWidth
            size="normal"
            variant="outlined"
            inputProps={{ min: 0, max: 99.99 }}
          />
        </Grid>
      </Grid>
      {empresa?.moduloServico && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControlLabel
              label="Considerar Ordem de Serviço"
              labelPlacement="end"
              control={
                <Checkbox
                  name="ordemServico"
                  checked={filtrosAvancados?.ordemServico || false}
                  onChange={(event) => onChangeCheckbox(event, "Ordem-Servico")}
                  color="primary"
                />
              }
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default FormFiltroAvancadoDesvioPreco;
